import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Step1({ calcObj, callback }: any) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const { check1 } = calcObj;

    const handleCheck = (idx: number) => {
        console.log('4444', { ...calcObj, check1: idx === check1 ? 0 : idx });
        callback({ ...calcObj, check1: idx === check1 ? 0 : idx });
    };

    return (
        <div className={`dpu-calculator-step1 ${css['dpu-calculator-step1']}`}>
            <p className="title">{t('step1_title')}</p>
            <ul className="items">
                {[1, 2]?.map((item: number) => (
                    <li className="item" key={item}>
                        <div className="item-img" onClick={() => handleCheck(item)}>
                            <EFPicture src={`/responsive/picture/dpu-calculator/1_${item}.jpg`} alt={t(`step1_text${item}`)} />
                            {check1 === item && (
                                <svg className="check-icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                    <rect width="28" height="28" rx="14" fill="#3F68E0" />
                                    <path d="M9 14.5L13 18.5L19 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}
                        </div>
                        <p className="item-text">{t(`step1_text${item}`)}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
